<script lang="ts">
  import type { IconsBaseProps } from './icons.types.ts';

  let { class: className, size = 6, title, ...rest }: IconsBaseProps = $props();
</script>

<svg viewBox="0 0 24 24" {...rest} width={size * 4} height={size * 4} class={className}>
  {#if title}<title>{title}</title>{/if}
  <path
    d="M2.61011 19C3.09011 19 3.52011 18.7 3.67011 18.25L4.68011 15.42H10.3301L11.3201 18.24C11.4801 18.7 11.9101 19 12.3901 19C13.1801 19 13.7201 18.21 13.4401 17.48L9.19011 6.17C8.93011 5.47 8.25011 5 7.50011 5C6.75011 5 6.07011 5.47 5.81011 6.17L1.56011 17.48C1.28011 18.21 1.83011 19 2.61011 19ZM7.44011 7.6H7.56011L9.59011 13.39H5.41011L7.44011 7.6ZM15.0001 12C15.0001 11.45 15.4501 11 16.0001 11H18.0001V9C18.0001 8.45 18.4501 8 19.0001 8C19.5501 8 20.0001 8.45 20.0001 9V11H22.0001C22.5501 11 23.0001 11.45 23.0001 12C23.0001 12.55 22.5501 13 22.0001 13H20.0001V15C20.0001 15.55 19.5501 16 19.0001 16C18.4501 16 18.0001 15.55 18.0001 15V13H16.0001C15.4501 13 15.0001 12.55 15.0001 12Z"
    fill="currentColor"
  />
</svg>
